












































































































import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import * as _ from 'lodash';
import surveys from '@/store/modules/surveys';
import users from '@/store/modules/users';

@Component
export default class UserFeedback extends Vue {
  @Prop() private formData?: any;
  private submitFeedbackDialog = false;
  private submitFeedbackSuccess = false;
  private submitFeedbackData?: any = {};
  private userFeedbackData?: any = {};
  private valid: boolean = false;
  private validated: boolean = false;
  private testArr?: any[] = [];
  private rules: any = [(element: any) => !!this.userFeedbackData[element.name] || 'Answer is required'];

  get elements() {
    return (this.form && this.form.survey_json && this.form.survey_json.pages[0].elements) || [];
  }

  private handleSubmitFeedbackSuccess() {
    this.submitFeedbackSuccess = !this.submitFeedbackSuccess;
  }

  private updateForm() {
    (this.$refs.surveyForm as any).validate();
    this.$forceUpdate();
  }

  get formErrors() {
    const errors: any = [];
    if (this.$refs.surveyForm) {
      (this.$refs.surveyForm as any).inputs.forEach((i: any) => {
        console.log('i', i);
        if (!i.valid) {
          errors.push(i.errorBucket);
        }
      });
    }
    return errors;
  }

  private handleSubmitFeedbackDialog(str: string) {
    if (str && str === 'submit') {
      this.validated = true;
      if ((this.$refs.surveyForm as any).validate()) {
        if (this.valid) {
          const response: any = {
            survey_id: this.form.id,
            status: 'completed',
            response: JSON.stringify(this.userFeedbackData),
          };
          // If the user has a last_survey with delayed status then update that survey with new response
          if (this.lastSurveyDelayed) {
            this.updateSurvey(response);
          } else {
            // If user's last survey is not with status delayed, create a new completed survey
            this.createSurvey(response);
          }
        }
      }
    }
  }

  private async updateSurvey(response: any) {
    await surveys.updateSurvey({ id: this.lastSurvey.id, response }).then((result: any) => {
      this.$swal('Thank you', 'Your Feedback was submitted', 'success');
      this.$events.emit('close-user-feedback');
      users.refresh();
      this.submitFeedbackDialog = !this.submitFeedbackDialog;
    });
  }

  private async createSurvey(response: any) {
    await surveys.createASurvey(response).then((result: any) => {
      this.$swal('Thank you', 'Your Feedback was submitted', 'success');
      this.$events.emit('close-user-feedback');
      users.refresh();
      this.submitFeedbackDialog = !this.submitFeedbackDialog;
    });
  }

  private skip() {
    let promise;
    const response = { survey_id: this.form.id, status: 'skipped' };
    // When user closes the modal using 'X' button, save it as skipped the survey
    // If the user has a last_survey with delayed status then update that survey with new response
    if (this.lastSurveyDelayed) {
      promise = surveys.updateSurvey({ id: this.lastSurvey.id, response });
    } else {
      // If user's last survey is not with status delayed, create a new completed survey
      promise = surveys.createASurvey(response);
    }

    promise.then((result: any) => {
      users.refresh().then((res: any) => {
        this.$events.emit('close-user-feedback');
      });
    });
  }

  private delayFb() {
    let promise;
    const response = { survey_id: this.form.id, status: 'delayed' };
    // When user closes the modal using 'X' button, save it as skipped the survey
    // If the user has a last_survey with delayed status then update that survey with new response
    if (this.lastSurveyDelayed) {
      promise = surveys.updateSurvey({ id: this.lastSurvey.id, response });
    } else {
      // If user's last survey is not with status delayed, create a new completed survey
      promise = surveys.createASurvey(response);
    }

    promise.then((result: any) => {
      users.refresh().then((res: any) => {
        this.$events.emit('close-user-feedback');
      });
    });
  }

  private handleUserFeedbackDialog() {
    Vue.swal({
      title: '',
      text: `Are you sure you don't want to submit feedback?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.skip();
      }
    });
  }

  get lastSurvey() {
    return this.$store.getters.userLoggedIn && this.$store.getters.currentUser.last_survey;
  }

  get lastSurveyDelayed() {
    return (
      this.$store.getters.userLoggedIn &&
      this.$store.getters.currentUser.last_survey &&
      this.$store.getters.currentUser.last_survey.status === 'delayed'
    );
  }

  private setupFormModel() {
    _.map(this.form.survey_json.pages[0].elements, (item) => {
      if (item.type === 'checkbox') {
        this.userFeedbackData[item.name] = [];
      }
    });
  }

  private created() {
    this.submitFeedbackData.user_id = this.$store.getters.currentUser.id;
    this.setupFormModel();
    this.$events.on('fb-prompt-action', (data: any) => {
      if (data.action === 'skip') {
        this.skip();
      } else if (data.action === 'delayed') {
        this.delayFb();
      }
    });
  }

  get form() {
    return this.formData;
  }
}
